<!--
 * Autorska prava pridržava Mali mol d.o.o. Pula
 * Copyright (c) 2016. by Mali mol d.o.o. Pula. All rights reserved.
 *
 * Mali mol d.o.o., Špiljavac 2, 52100 Pula, Croatia
 -->

<template>
  <div
    v-if="updateAvailable"
    role="alert"
    class="relative w-full z-[60] flex items-center justify-center gap-4 px-4 py-2 bg-surface-0 dark:bg-surface-900 border-b border-surface text-color shadow-md"
  >
    <span class="text-sm">{{ t('update.wasm_available') }}</span>
    <Button :label="t('update.reload')" size="small" @click="reload" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';
import { useWasmUpdatePoll } from '@/composables/useWasmUpdatePoll';

export default defineComponent({
  name: 'WasmUpdateBanner',
  components: { Button },
  setup() {
    const { t } = useI18n({ useScope: 'global' });
    const { updateAvailable } = useWasmUpdatePoll();

    const reload = (): void => {
      window.location.reload();
    };

    return { t, updateAvailable, reload };
  },
});
</script>
